import { AxiosResponse } from "axios";
import { CreateSurveyResult } from "../../Common/domain/entities/features/surveyResults/dto";
import { doPost } from "../../Common/utils/https";
import { getRequestHeaders } from "../../Common/utils/https";
import { cloudFunctionsUrl } from "../firebase";

const baseUrl = cloudFunctionsUrl;

export const createSurveyResults = async (
  data: CreateSurveyResult
): Promise<AxiosResponse> => {
  const url = `${baseUrl}analytics/v2/survey-results`;
  const headers = await getRequestHeaders(true);
  return doPost(url, headers, data);
};
